import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import Robot from './Robot';

import OlMap from '@/helpers/OlMap';
import useCameraFeedback from '@/hooks/useCameraFeedback';
import useMission, { PX4 } from '@/hooks/useMissionForMavLink';
import EventEmitter from '@/libs/EventEmitter';

const MapMapper = ({ data: robot }) => {
  const robotColor = useRef(robot.color);
  const globalPosition = useSelector((state) => state.telemetry[robot.id].globalPosition);
  const homePosition = useSelector((state) => state.telemetry[robot.id].homePosition);

  useCameraFeedback(robot.id);
  useMission(PX4, robot);

  useMountEffect(() => {
    const subscribeToken = EventEmitter.subscribe(`${robot.id}/event/removeGoto`, () => {
      OlMap.removeGoto(robot.id);
    });

    return () => {
      EventEmitter.unsubscribe(subscribeToken);
      OlMap.removeHome(robot.id);
      OlMap.removeGoto(robot.id);
    };
  });

  useUpdateEffect(() => {
    const { lat, lng } = globalPosition;

    OlMap.addHomePath(robot.id, { lat, lng });
    OlMap.addGotoPath(robot.id, { lat, lng }, robotColor.current);
  }, [globalPosition]);

  useUpdateEffect(() => {
    const { lat, lng } = homePosition;

    OlMap.addHomeMarker(robot.id, { lat, lng }, robotColor.current);
  }, [homePosition]);

  useUpdateEffect(() => {
    robotColor.current = robot.color;
    OlMap.changeColor(robot.id, robotColor.current);
  }, [robot.color]);

  return <Robot data={robot} />;
};

export default MapMapper;
